export const MATHCES_GET_MATCHES = "MATHCES_GET_MATCHES";
export const MATHCES_GET_MATCHES_RQUESTED = "MATHCES_GET_MATCHES_RQUESTED";
export const MATHCES_GET_MATCHES_SUCCESS = "MATHCES_GET_MATCHES_SUCCESS";
export const MATHCES_GET_MATCHES_FAILED = "MATHCES_GET_MATCHES_FAILED";
export const MATHCES_GET_MATCHES_CLEAR = "MATHCES_GET_MATCHES_CLEAR";
